export const DEVICES_BULK_ACTIONS_OPEN_MODAL = "DEVICES_BULK_ACTIONS_OPEN_MODAL";
export const DEVICES_BULK_ACTIONS_CLOSE_MODAL = "DEVICES_BULK_ACTIONS_CLOSE_MODAL";

export const DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST = "DEVICES_BULK_ACTIONS_SEARCH_DEVICES_REQUEST";
export const DEVICES_BULK_ACTIONS_SEARCH_DEVICES_RESULT = "DEVICES_BULK_ACTIONS_SEARCH_DEVICES_RESULT";

export const DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST = "DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_REQUEST";
export const DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_RESULT = "DEVICES_BULK_ACTIONS_SEARCH_DEVICES_MODEL_RESULT";

export const DEVICES_BULK_ACTIONS_REQUEST = "DEVICES_BULK_ACTIONS_REQUEST";
export const DEVICES_BULK_ACTIONS_RESULT = "DEVICES_BULK_ACTIONS_RESULT";

export const DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST = "DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_REQUEST";
export const DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_RESULT = "DEVICES_BULK_ACTIONS_SEARCH_COMMANDS_RESULT";

export const DEVICES_BULK_SEND_MESSAGE_REQUEST = "DEVICES_BULK_SEND_MESSAGE_REQUEST";
export const DEVICES_BULK_SEND_MESSAGE_RESULT = "DEVICES_BULK_SEND_MESSAGE_RESULT";

export const DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST = "DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_REQUEST";
export const DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_RESULT = "DEVICES_BULK_ACTIONS_GET_SUPPORTED_TIMEZONES_RESULT";
